import { Fragment } from 'react';

import { AccordionDetails, Button } from '@frontierag/frontier-ui-library';
import type { IGenericObject } from 'types';

import { styles } from './styles';
import type { IActionCell } from './types';

interface IAccordionRowActions {
  data: IGenericObject;
  actionCells: IActionCell[];
}

export default function AccordionRowActions({ data, actionCells }: IAccordionRowActions) {
  if (!actionCells.length) {
    return null;
  }

  return (
    <AccordionDetails data-testid="accordion-row-actions" sx={styles.accordionFooter}>
      {actionCells.map((field, index) => {
        if (field?.component?.type !== 'button') {
          return null;
        }

        const actionButtonProps = field.component.props?.(data);
        const { sx: actionButtonSx, ...actionButtonRestProps } = actionButtonProps || {};

        return (
          <Fragment key={`action-row-${index}`}>
            <Button
              data-testid={`${field.name}-action`}
              variant={field.component.variant}
              color={field.component.color}
              size={field.component.size}
              onClick={() => field.onActionClick(data)}
              sx={[
                styles.actionButton,
                ...(Array.isArray(actionButtonSx) ? actionButtonSx : [actionButtonSx]),
              ]}
              {...actionButtonRestProps}
            >
              {typeof field.displayValue === 'function'
                ? field.displayValue(data)
                : field.displayValue}
            </Button>
          </Fragment>
        );
      })}
    </AccordionDetails>
  );
}
